import React, { useState, useEffect, useContext } from "react";
import "../App.css";
import axios from "axios";
import Sidebar from "../componenteExtra/SidebarsocioGET";
import { GrupoContext } from "../GrupoContext";
import Modal from "react-modal";
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement("#root");

const VerAsistente = () => {
  const { grupo } = useContext(GrupoContext);
  const [staffList, setStaffList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [activities, setActivities] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_staff`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setStaffList(response.data);
      })
      .catch((error) => console.error("Error fetching data: ", error));
  }, []);

  const openModal = (staffName) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/activities_by_staff/${staffName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setActivities(response.data);
        setSelectedStaff(staffName);
        setModalIsOpen(true);
      })
      .catch((error) => console.error("Error fetching activities:", error));
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedStaff(null);
    setActivities([]);
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Ver todos los staff</h1>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Número de Grupo</th>
                  <th>Nombre Asistente</th>
                  <th>Cantidad de Actividades Asignadas</th>
                  <th>Actividades Iniciadas</th>
                  <th>Completadas Exitosas</th>
                  <th>Completadas Con Dificultades</th>
                  <th>Porcentaje de Eficacia</th>
                  <th>Ver Actividades</th>
                </tr>
              </thead>
              <tbody>
                {staffList.map((staff, index) => {
                  const totalActivities =
                    staff.nro_actividades_sin_complicaciones +
                    staff.nro_actividades_con_complicaciones;
                  const effectiveness =
                    totalActivities > 0
                      ? (
                          (staff.nro_actividades_sin_complicaciones /
                            totalActivities) *
                          100
                        ).toFixed(2)
                      : "N/A";

                  return (
                    <tr key={index}>
                      <td>{staff.numero_grupo}</td>
                      <td>{staff.nombre_asistente}</td>
                      <td>{staff.cantidad_actividad_asignadas}</td>
                      <td>{staff.actividades_iniciadas}</td>
                      <td>{staff.nro_actividades_sin_complicaciones}</td>
                      <td>{staff.nro_actividades_con_complicaciones}</td>
                      <td>{effectiveness} %</td>
                      <td>
                        <button
                          onClick={() => openModal(staff.nombre_asistente)}
                        >
                          Ver Actividades
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Actividades del Staff"
          >
            <h2>Actividades de {selectedStaff}</h2>
            <button onClick={closeModal}>Cerrar</button>
            <div className="activities-table-container">
              <table className="activities-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Código Proyecto</th>
                    <th>Estado Asignaciones</th>
                    <th>Razón Social</th>
                    <th>Filial</th>
                    <th>Socio de auditoría</th>
                    <th>Rubro GET</th>
                    <th>Nombre Actividad GET</th>
                    <th>Número Grupo</th>
                    <th>Jefe de Grupo</th>
                    <th>Subrogante</th>
                    <th>Fecha de Entrega Información</th>
                    <th>Enlace Comentario</th>
                    <th>Staff Asignado</th>
                    <th>Fecha de Inicio</th>
                    <th>Fecha de Término</th>
                    <th>Estados Staff</th>
                    <th>Fecha Estado Staff</th>
                    <th>Horas GET</th>
                    <th>Horas Estándar</th>
                    <th>Comentario Líder</th>
                    <th>Comentario Senior GET</th>
                    <th>Pausa</th>
                    <th>Comentario Pausa</th>
                  </tr>
                </thead>
                <tbody>
                  {activities.map((activity, index) => (
                    <tr key={index}>
                      <td>{activity.id}</td>
                      <td>{activity.codigo_proyecto}</td>
                      <td>{activity.estado_asignaciones}</td>
                      <td>{activity.razon_social}</td>
                      <td>{activity.filial}</td>
                      <td>{activity.encargado_auditoria}</td>
                      <td>{activity.rubro_get}</td>
                      <td>{activity.nombre_actividad_get}</td>
                      <td>{activity.numero_grupo}</td>
                      <td>{activity.jefe_grupo}</td>
                      <td>{activity.subrogante}</td>
                      <td>{activity.fecha_entrega_informacion}</td>
                      <td>{activity.enlace_comentario}</td>
                      <td>{activity.staff_asignado}</td>
                      <td>{activity.fecha_de_inicio}</td>
                      <td>{activity.fecha_de_termino}</td>
                      <td>{activity.estados_staff}</td>
                      <td>{activity.fecha_estado_staff}</td>
                      <td>{activity.horas_get}</td>
                      <td>{activity.horas_estandar}</td>
                      <td>{activity.comentario_lider}</td>
                      <td>{activity.comentario_seniorget}</td>
                      <td>{activity.pausa}</td>
                      <td>{activity.comentario_pausa}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default VerAsistente;
